"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var HttpError_1 = __importDefault(require("../utils/exceptions/HttpError"));
var ApiConfiguration_1 = __importDefault(require("../utils/models/ApiConfiguration"));
var axios_1 = __importDefault(require("axios"));
var ApiClient = /** @class */ (function () {
    function ApiClient() {
    }
    /**
     * perform the GET action
     * @param url
     * @param params
     */
    ApiClient.get = function (url, params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._fetch({
                        url: url,
                        method: 'GET',
                        params: params,
                        headers: ApiConfiguration_1.default.getAllHeaders()
                    })];
            });
        });
    };
    /**
     * perform the POST action
     * @param url
     * @param body
     * @param params
     */
    ApiClient.post = function (url, body, params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._fetch({
                        url: url,
                        method: 'POST',
                        params: params,
                        data: body,
                        headers: ApiConfiguration_1.default.getAllHeaders()
                    })];
            });
        });
    };
    /**
     * perform the PATCH action
     * @param url
     * @param body
     * @param params
     */
    ApiClient.patch = function (url, body, params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._fetch({
                        url: url,
                        method: 'PATCH',
                        params: params,
                        data: body,
                        headers: ApiConfiguration_1.default.getAllHeaders()
                    })];
            });
        });
    };
    /**
     * perform the PUT action
     * @param url
     * @param body
     * @param params
     */
    ApiClient.put = function (url, body, params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._fetch({
                        url: url,
                        method: 'PUT',
                        params: params,
                        data: body,
                        headers: ApiConfiguration_1.default.getAllHeaders()
                    })];
            });
        });
    };
    /**
     * perform the DELETE action
     * @param url
     * @param params
     */
    ApiClient.delete = function (url, params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._fetch({
                        url: url,
                        method: 'DELETE',
                        params: params,
                        headers: ApiConfiguration_1.default.getAllHeaders()
                    })];
            });
        });
    };
    ApiClient._fetch = function (requestConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, axios_1.default)(__assign(__assign({}, requestConfig), { url: "".concat(ApiConfiguration_1.default.getBaseUrl()).concat(requestConfig.url) }))];
                    case 1:
                        response = _a.sent();
                        if (response.status.toString()[0] === '2') {
                            if (Object.keys(response.data).length === 1
                                && 'data' in response.data) {
                                return [2 /*return*/, Promise.resolve(response.data.data)];
                            }
                            return [2 /*return*/, Promise.resolve(response.data)];
                        }
                        this._log({
                            url: requestConfig.url,
                            params: requestConfig.params,
                            headers: requestConfig.headers,
                            response: response.data
                        });
                        return [2 /*return*/, Promise.reject(new HttpError_1.default(response.data.message || '', response.status, response.data.errors, response.data))];
                    case 2:
                        e_1 = _a.sent();
                        this._log({
                            url: requestConfig.url,
                            params: requestConfig.params,
                            headers: requestConfig.headers,
                            response: ''
                        });
                        return [2 /*return*/, Promise.reject(new HttpError_1.default(e_1.response.data.message, e_1.response.status, e_1.response.data.errors, e_1.response.data))];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ApiClient._log = function (input) {
        if (typeof window !== 'undefined') {
            return;
        }
        // eslint-disable-next-line no-console
        console.error(input);
    };
    return ApiClient;
}());
exports.default = ApiClient;
